import axios from "@/assets/js/api";
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示

export default {
  name: "DiscountManagement",
  data() {
    return {
      packages: [],
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      showEditModal: false,
      showNewModal: false, // 控制新增方案彈窗的顯示
      editPackageData: {
        id: "",
        name: "",
        basePrice: 0,
      },
      newPackageData: {
        name: "", // 新增方案的名稱
        basePrice: 0, // 新增方案的價格
      },
    };
  },
  computed: {
    filteredPackages() {
      if (!Array.isArray(this.packages)) return [];

      let result = this.packages;

      // 根據搜尋關鍵字篩選
      const query = this.searchQuery.trim().toLowerCase();
      if (query) {
        result = result.filter(
          (pkg) =>
            pkg.name.toLowerCase().includes(query) ||
            pkg.id.toString().includes(query)
        );
      }

      return result;
    },
    totalPages() {
      return Math.ceil(this.filteredPackages.length / this.itemsPerPage);
    },
    paginatedPackages() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPackages.slice(
        startIndex,
        startIndex + this.itemsPerPage
      );
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
  },
  methods: {
    async fetchPackages() {
      try {
        const response = await axios.get("/Packages");
        this.packages = response.data;
      } catch (error) {
        console.error("無法取得專案資料:", error);
      }
    },
    editPackage(packageData) {
      this.editPackageData = { ...packageData };
      this.showEditModal = true;
    },
    async saveEdit() {
      try {
        const updatedPackage = { ...this.editPackageData };
        await axios.put(`/Packages/${updatedPackage.id}`, updatedPackage);

        // 重新獲取資料
        await this.fetchPackages();
        this.showEditModal = false;
      } catch (error) {
        console.error("更新方案失敗:", error);
      }
    },
    async addPackage() {
      if (!this.newPackageData.name || this.newPackageData.basePrice <= 0) {
        Swal.fire({
          icon: "warning",
          title: "資料未填寫完整",
          text: "請完整填寫資料",
          confirmButtonText: "確定",
        });

        return;
      }
      try {
        const newPackage = { ...this.newPackageData };
        await axios.post("/Packages", newPackage);
        await this.fetchPackages();
        this.closeNewModal();
        Swal.fire({
          icon: "success",
          title: "新增成功",
          text: "新增方案成功！",
          confirmButtonText: "確定",
        });
      } catch (error) {
        console.error("新增方案失敗:", error);
        Swal.fire({
          icon: "error",
          title: "新增失敗",
          text: "新增方案時發生錯誤，請稍後再試！",
          confirmButtonText: "確定",
        });
      }
    },
    async confirmDelete() {
      // 顯示確認提示框
      const confirmed = confirm("確定要刪除這筆訂單嗎？此操作無法恢復！");
      if (confirmed) {
        try {
          // 呼叫後端刪除 API
          await this.deletePackage(this.editPackageData.id);
          Swal.fire({
            icon: "success",
            title: "刪除成功",
            text: "訂單已成功刪除！",
            confirmButtonText: "確定",
          });
          
          this.closeEditModal();
          // 刷新列表或執行其他必要的操作
          this.fetchPackages();
        } catch (error) {
          console.error("刪除方案失敗：", error);
          Swal.fire({
            icon: "error",
            title: "刪除失敗",
            text: "刪除方案時發生錯誤，請稍後再試！",
            confirmButtonText: "確定",
          });
          
        }
      }
    },
    async deletePackage(id) {
      // 使用 Axios 發送 DELETE 請求
      try {
        const apiUrl = `/Packages/${id}`;
        await axios.delete(apiUrl); // 改用直接導入的 axios
      } catch (error) {
        console.error("刪除方案失敗：", error);
        throw error; // 將錯誤拋出以便進一步處理
      }
    },
    openNewModal() {
      this.showNewModal = true;
      this.newPackageData = { name: "", basePrice: 0 };
    },
    closeNewModal() {
      this.showNewModal = false;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    prevPage() {
      if (this.hasPreviousPage) this.currentPage--;
    },
    nextPage() {
      if (this.hasNextPage) this.currentPage++;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.fetchPackages(); // 修正：改為呼叫 fetchPackages 而不是 fetchRooms
  },
};
